import { useEffect } from "react";
import Footer from "./Footer";
import Header from "./Header";

const AppLayout = ({ children }: ComponentPropsType) => {
  useEffect(() => {
    const lang = localStorage.getItem("romotors_web_lang") || "en";
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    document.body.style.textAlign = lang === "ar" ? "right" : "left";
  }, []);

  return (
    <>
      <div style={{ flex: 1 }}>
        <Header />
        {children}
      </div>
      <Footer />
    </>
  );
};

export default AppLayout;

type ComponentPropsType = {
  children: any;
};
